module.exports = __webpack_public_path__ + "static/media/StarChack.39277a8a.svg";